import { createApp } from "vue";
import loadAntdComponent from "@/plugins/antd";
import App from "./App.vue";
import router from "./router";
import Bus from "@/utils/bus";
import { store } from "./store";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import print from "vue3-print-nb";
import "ant-design-vue/dist/reset.css";
// import loadIconComponent from "@/plugins/antdIcon";
// 引入tailwind
// import "tailwindcss/tailwind.css";
// 引入全局样式
import "./styles/index.less";
import "animate.css";

dayjs.locale("zh-cn");
const app = createApp(App);
loadAntdComponent(app);
// loadIconComponent(app);
app.use(router);
app.use(store);
app.use(print);
// app.component("contextHolder", contextHolder);
app.mount("#app");
// 全局挂载$Bus方法，用于中央事件总线事件
app.config.globalProperties.$Bus = Bus;
